import { useOnboardingStatus } from './useOnboardingStatus';

/**
 * Returns the tenant's firm_type from the onboarding status endpoint.
 * Falls back to 'default' when not set (onboarding skipped or not yet completed).
 *
 * Known values: 'architect' | 'general_contractor' | 'engineering_consultant' | 'other'
 */
export function useFirmType(): string {
  const { data } = useOnboardingStatus();
  return (data as any)?.firm_type ?? 'default';
}
